import {i18n} from "@/plugins/i18n";
import StatusColumn from './../components/status-column-dedicated.vue';

const statusTemplate = (row, index, datatable) => {
    let template = new StatusColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 80,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('label.cat_name'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'collective_shops',
        title: i18n.t('label.gateway_title'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'is_deleted',
        title: i18n.t('label.status'),
        sortable: false,
        textAlign: 'center',
        template: (row, index, datatable) => {
          return statusTemplate(row, index, datatable)
        },
    }
]